import { Component } from '@angular/core';
import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { IFloatingFilterParams, SetFilterModel } from 'ag-grid-community';

@Component({
  standalone: false,
  selector: 'mm-set-floating-filter',
  templateUrl: './set-floating-filter.component.html',
  styleUrls: ['./set-floating-filter.component.scss'],
})
export class SetFloatingFilterComponent implements AgFloatingFilterComponent {
  params: IFloatingFilterParams;
  currentValue: null | string | string[] = 'Filter';

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  onParentModelChanged(parentModel: SetFilterModel) {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      this.currentValue = 'Filter';
    } else if (parentModel.values.length > 1) {
      this.currentValue = `${parentModel.values?.length} selections`;
    } else {
      this.currentValue = parentModel.values as string[];

    }
  }

  showFilterPopup() {
    this.params.showParentFilter();
  }
}